import React from 'react';
import * as _ from 'lodash';
import WorkScheduleService from '../../services/Works';
import WorkSummariesService from '../../services/WorkSummaries';
import DailyWorkInformationService from '../../services/DailyWorkInformation';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import {
  WORKER_TYPES,
  SCHEDULE_STATUS,
  PRIVATE_PARTNER_COMPANY_FLAG,
} from '../../utilities/constants';
import regex from '../../utilities/validateRegex';
import { isLoginUserPrimaryCompany } from '../../utilities/roleUtility';

const addEmployeeOverQty = 65000;
const overQtyErrorMessage = '65000未満で入力してください。';

/**
 * ダイアログのコンポーネント
 * 【表示項目の全人工合計】ボタン
 */
class WorkResultManHours extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      totalEmployee: 0,
      addEmployee: 0,
      contractorTotal: 0,
      contractorEarly: 0,
      contractorLate: 0,
      hireTotal: 0,
      hireEarly: 0,
      hireLate: 0,
      worker_work_hour: 0,
      manager_work_hour: 0,
    };
    this.isSubmittingFlag = false; //多重登録防止Flag

    this.employeeSubmit = this.employeeSubmit.bind(this); // 社員数登録
  }

  componentDidMount() {
    const params = this.props.mergedSearchParams;

    if (
      _.isUndefined(params.dayworker_type) ||
      params.dayworker_type === String(WORKER_TYPES.contractor.id)
    ) {
      const contract = {
        ...params,
        schedule_flag: SCHEDULE_STATUS.result.id,
        dayworker_type: WORKER_TYPES.contractor.id,
        private_partner_company_flag: PRIVATE_PARTNER_COMPANY_FLAG.noPrivate.id,
      };
      WorkScheduleService.groupWorkHours(this.props.fieldId, contract).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({
            contractorTotal: response.data.entities.work.man_hours,
          });
        }
      );
      WorkScheduleService.groupEarlyHours(this.props.fieldId, contract).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({
            contractorEarly: response.data.entities.work.early_hours,
          });
        }
      );
      WorkScheduleService.groupOverHours(this.props.fieldId, contract).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({
            contractorLate: response.data.entities.work.over_hours,
          });
        }
      );
    }
    if (
      _.isUndefined(params.dayworker_type) ||
      params.dayworker_type === String(WORKER_TYPES.regular.id)
    ) {
      const hire = {
        ...params,
        schedule_flag: SCHEDULE_STATUS.result.id,
        dayworker_type: WORKER_TYPES.regular.id,
        private_partner_company_flag: PRIVATE_PARTNER_COMPANY_FLAG.noPrivate.id,
      };
      WorkScheduleService.groupWorkHours(this.props.fieldId, hire).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({ hireTotal: response.data.entities.work.man_hours });
        }
      );
      WorkScheduleService.groupEarlyHours(this.props.fieldId, hire).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({ hireEarly: response.data.entities.work.early_hours });
        }
      );
      WorkScheduleService.groupOverHours(this.props.fieldId, hire).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({ hireLate: response.data.entities.work.over_hours });
        }
      );
    }
    DailyWorkInformationService.managerCount(this.props.fieldId, {
      date_from: params.date_from,
      date_to: params.date_to,
    }).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        addEmployee: response.data.entities.daily_worker_information,
      });
    });
    DailyWorkInformationService.managerCount(this.props.fieldId, {
      date_to: params.date_to,
    }).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        totalEmployee: response.data.entities.daily_worker_information,
      });
    });
    WorkSummariesService.getTotalWokerManagerHours({
      field_id: this.props.fieldId,
      date_to: params.date_to,
      work_hour_zone: params.work_hour_zone,
    }).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        worker_work_hour:
          response.data.entities.work_summaries.worker_work_hour,
        manager_work_hour:
          response.data.entities.work_summaries.manager_work_hour,
      });
    });
  }

  /**
   * @description 社員数登録
   */
  // isSubmittingFlagがTrueならemployeeSubmitが発生しないため、多重登録が行わない
  employeeSubmit() {
    if (!this.validate(this.state.addEmployee, true) || this.isSubmittingFlag) {
      return;
    } else {
      this.isSubmittingFlag = true;
      const params = {
        work_date: SessionStorageService.getToDate(),
        // getFromDate ではないか？？
        // 元コードが getToDate だった

        manager_count: Number(this.state.addEmployee),
      };
      DailyWorkInformationService.registerManagerCount(
        this.props.fieldId,
        params
      ).then(response => {
        if (response.result === true) {
          this.props.onClose();
        } else if (response.status === 400) {
          // 400が返ってきた場合は入力数量のエラー
          // 入力制御しているので来ることはないはずだがメッセージ表示
          // フロントで65000未満をエラーしているがサーバー側では65535が最大値
          this.setState({
            addEmployeeErrorMessage: overQtyErrorMessage,
          });
        }
        this.isSubmittingFlag = false;
      });
    }
  }
  /**
   * @description 社員数入力
   * @param {string} value 入力社員数
   */
  handleEditEmployee = value => {
    if (!this.checkInteger(value)) {
      return;
    }
    this.setAddEmployee(value);
  };

  /**
   * @description 社員数操作_スピンボタン
   * @param {string} spinType up: 加算 down: 減算
   */
  spinEditEmployee(spinType) {
    let addEmployee = Number(this.state.addEmployee);
    if (spinType === 'up') {
      addEmployee += 1;
    } else {
      addEmployee -= 1;
    }

    this.setAddEmployee(addEmployee);
  }

  setAddEmployee = value => {
    const addEmployee = Number(value);
    this.setState({ addEmployee });
    this.validate(addEmployee, false);
  };

  checkOverEmployee = number => {
    if (_.toNumber(number) < addEmployeeOverQty) {
      return true;
    }
    return false;
  };

  /*
   * 整数チェック
   */
  checkInteger = number => {
    if (!_.toString(number).match(regex.pattern.int) && number !== '') {
      return false;
    }
    if (_.includes(number, '.')) {
      return false;
    }
    return true;
  };

  validate = (addEmployee, isSubmit) => {
    // 入力で制限しているので少数点以下があることはないはずだが念のためチェック
    if (isSubmit && !this.checkInteger(addEmployee)) {
      this.setState({ addEmployeeErrorMessage: '整数で入力してください。' });
      return false;
    }
    if (!this.checkOverEmployee(addEmployee)) {
      this.setState({
        addEmployeeErrorMessage: overQtyErrorMessage,
      });
      return false;
    }
    this.setState({ addEmployeeErrorMessage: '' });
    return true;
  };

  render() {
    const { mergedSearchParams, onClose } = this.props;
    const {
      contractorTotal,
      contractorEarly,
      contractorLate,
      hireTotal,
      hireEarly,
      hireLate,
      totalEmployee,
      addEmployee,
      worker_work_hour,
      manager_work_hour,
    } = this.state;
    const dateTo = mergedSearchParams.date_to;
    const dateFrom = mergedSearchParams.date_from;
    const showContractType =
      _.isUndefined(this.props.mergedSearchParams.dayworker_type) ||
      this.props.mergedSearchParams.dayworker_type ===
        String(WORKER_TYPES.contractor.id);
    const showRegularType =
      _.isUndefined(this.props.mergedSearchParams.dayworker_type) ||
      this.props.mergedSearchParams.dayworker_type ===
        String(WORKER_TYPES.regular.id);

    return (
      <div className='dialog dialog--modal'>
        <div className='dialog__header'>
          <span className='dialog__title'>表示項目の全人工合計</span>
        </div>
        <div className='dialog__body scroll'>
          <div className='dashboard dashboard--dialog'>
            <div className='dashboard__wrapper contents__vertical'>
              {showContractType ? (
                <div className='dashboard__section'>
                  <div className='dashboard__section-title'>請負合計</div>
                  <div className='dashboard__boards'>
                    <div className='label-value label-value--dashboard__boards'>
                      <div className='label'>人工</div>
                      <div className='value'>{contractorTotal}</div>
                    </div>
                    <div className='label-value label-value--dashboard__boards'>
                      <div className='label'>早/残</div>
                      <div className='value'>
                        {contractorEarly}/{contractorLate}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
              {showRegularType ? (
                <div className='dashboard__section'>
                  <div className='dashboard__section-title'>常傭合計</div>
                  <div className='dashboard__boards'>
                    <div className='label-value label-value--dashboard__boards'>
                      <div className='label'>人工</div>
                      <div className='value'>{hireTotal}</div>
                    </div>
                    <div className='label-value label-value--dashboard__boards'>
                      <div className='label'>早/残</div>
                      <div className='value'>
                        {hireEarly}/{hireLate}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
          {isLoginUserPrimaryCompany() && (
            <div className='dashboard dashboard--dialog'>
              <div className='dashboard__section'>
                <div className='dashboard__section-title'>社員</div>
                <div className='dashboard__boards'>
                  <div className='label-value label-value--dashboard__boards'>
                    <div className='label'>社員</div>
                    {dateFrom !== dateTo ? (
                      <div className='value'>{addEmployee}人</div>
                    ) : (
                      <React.Fragment>
                        <div id='employee' className='value'>
                          <div className='boards-value-input'>
                            <div className='dropdown-calender'>
                              <div className='dropdown-calender__input'>
                                <input
                                  name='update_total_employee'
                                  type='text'
                                  value={addEmployee}
                                  onChange={e =>
                                    this.handleEditEmployee(e.target.value)
                                  }
                                />
                                <div className='btn-spin'>
                                  <button
                                    className='btn-spin__up'
                                    onClick={() => this.spinEditEmployee('up')}
                                  >
                                    <i className='i_arrow-top' />
                                  </button>
                                  <button
                                    disabled={Number(addEmployee) === 0}
                                    className='btn-spin__down'
                                    onClick={() =>
                                      this.spinEditEmployee('down')
                                    }
                                  >
                                    <i className='i_arrow-bottom' />
                                  </button>
                                </div>
                              </div>
                            </div>
                            <span className='boards-value-input__text'>人</span>
                          </div>
                        </div>
                        <div className='validate-message show'>
                          {this.state.addEmployeeErrorMessage}
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                  <div className='label-value label-value--dashboard__boards'>
                    <div className='label'>本日までの累計</div>
                    <div className='value'>{totalEmployee}人</div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {isLoginUserPrimaryCompany() && (
            <div className='dashboard dashboard--dialog'>
              <div className='dashboard__section'>
                <div className='dashboard__section-title'>延べ労働時間</div>
                <div className='dashboard__boards'>
                  <div className='label-value label-value--dashboard__boards'>
                    <div className='label'>社員</div>
                    <div className='value'>{manager_work_hour}H</div>
                  </div>
                  <div className='label-value label-value--dashboard__boards'>
                    <div className='label'>協力会社</div>
                    <div className='value'>{worker_work_hour}H</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className='dialog__footer'>
          <button
            id='man-hour-dialog-close'
            className='btn--sub'
            onClick={() => {
              onClose();
            }}
          >
            戻る
          </button>
          {isLoginUserPrimaryCompany() && dateFrom === dateTo && (
            <button
              id='man-hour-dialog-register'
              className='btn'
              onClick={this.employeeSubmit}
            >
              登録
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default WorkResultManHours;



// WEBPACK FOOTER //
// ./src/components/modals/WorkResultManHours.jsx